import { InteractionParticipantStatus } from "./interaction-participants-status.enum";
var ParticipantInfoBuilder = /** @class */ (function () {
    function ParticipantInfoBuilder() {
        this.participantInfo = {
            firstJoinDate: Date.now(),
            lastLeaveDate: Date.now(),
            status: InteractionParticipantStatus.ACTIVE,
            agent: true,
        };
    }
    ParticipantInfoBuilder.prototype.withFirstJoinDate = function (date) {
        this.participantInfo.firstJoinDate = date;
        return this;
    };
    ParticipantInfoBuilder.prototype.withLastLeaveDate = function (date) {
        this.participantInfo.lastLeaveDate = date;
        return this;
    };
    ParticipantInfoBuilder.prototype.withStatus = function (status) {
        this.participantInfo.status = status;
        return this;
    };
    ParticipantInfoBuilder.prototype.withAgent = function (agent) {
        this.participantInfo.agent = agent;
        return this;
    };
    ParticipantInfoBuilder.prototype.build = function () {
        return this.participantInfo;
    };
    return ParticipantInfoBuilder;
}());
export { ParticipantInfoBuilder };
//# sourceMappingURL=participant-info.builder.js.map